import * as React from 'react';
import { Badge as FluentBadge, type BadgeProps as FluentBadgeProps, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

type LegacyVariant = 'default' | 'secondary' | 'destructive' | 'outline';
type LegacySize = 'default' | 'sm' | 'lg';

export type BadgeProps = Omit<FluentBadgeProps, 'appearance' | 'size'> & {
  variant?: LegacyVariant;
  size?: LegacySize;
};

function mapAppearance(variant?: LegacyVariant): FluentBadgeProps['appearance'] {
  switch (variant) {
    case 'outline':
      return 'outline';
    case 'secondary':
      return 'tint';
    case 'destructive':
      return 'filled';
    case 'default':
    default:
      return 'filled';
  }
}

function mapSize(size?: LegacySize): FluentBadgeProps['size'] {
  switch (size) {
    case 'sm':
      return 'small';
    case 'lg':
      return 'large';
    case 'default':
    default:
      return 'medium';
  }
}

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXXS,
    paddingLeft: `calc(${tokens.spacingHorizontalSNudge} + 2px)`,
    paddingRight: `calc(${tokens.spacingHorizontalSNudge} + 2px)`,
    borderRadius: tokens.borderRadiusCircular,
    whiteSpace: 'nowrap',
    '@media (max-width: 768px)': {
      paddingLeft: tokens.spacingHorizontalXS,
      paddingRight: tokens.spacingHorizontalXS,
    },
  },
});

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'default', className, ...rest }) => {
  const styles = useStyles();
  return (
    <FluentBadge
      appearance={mapAppearance(variant)}
      size={mapSize(size)}
      color={variant === 'destructive' ? 'danger' : undefined}
      className={mergeClasses(styles.root, className)}
      {...rest}
    >
      {children}
    </FluentBadge>
  );
};


